function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import classnames from 'classnames';
import Button from "../button";
import Typography from "../typography";
import AlertMessage from "../alert-message";
import StatusBox from "../status-box";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MobileInsurerDetail = function MobileInsurerDetail(props) {
  var insurerLogo = props.insurerLogo,
    insurerName = props.insurerName,
    insurerType = props.insurerType,
    statusProps = props.statusProps,
    _props$buttons = props.buttons,
    buttons = _props$buttons === void 0 ? [] : _props$buttons,
    _props$infoGroups = props.infoGroups,
    infoGroups = _props$infoGroups === void 0 ? [] : _props$infoGroups,
    style = props.style,
    className = props.className,
    messageBar = props.messageBar;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('igloo-policy-mobile-detail-container', className),
    style: style,
    children: [messageBar && /*#__PURE__*/_jsx(AlertMessage, _objectSpread(_objectSpread({}, messageBar), {}, {
      style: {
        marginBottom: 24
      }
    })), /*#__PURE__*/_jsxs("div", {
      className: "mobile-detail-top",
      children: [insurerLogo && /*#__PURE__*/_jsx("div", {
        className: "mobile-detail-top-insurer-logo",
        children: insurerLogo
      }), /*#__PURE__*/_jsxs("div", {
        className: "mobile-detail-top-insurer-info",
        children: [/*#__PURE__*/_jsx("div", {
          className: "insurer-name",
          children: /*#__PURE__*/_jsxs(Typography, {
            level: "h4",
            children: [insurerName, " ", insurerType]
          })
        }), /*#__PURE__*/_jsx(StatusBox, _objectSpread({}, statusProps))]
      })]
    }), buttons && buttons.map(function (item, index) {
      return item.render ? item.render() : /*#__PURE__*/_jsx(Button, {
        icon: item.icon,
        onClick: function onClick() {
          return item.onClick && item.onClick(props);
        },
        type: item.type || 'default',
        style: {
          width: '100%',
          marginBottom: "".concat(index === buttons.length - 1 ? 0 : 16, "px")
        },
        children: /*#__PURE__*/_jsx(Typography, {
          level: "h4",
          children: item.label
        })
      }, String(item) + index);
    }), /*#__PURE__*/_jsx("div", {
      className: "dividing-line"
    }), infoGroups.map(function (group, index) {
      var sectionName = group.sectionName,
        infoItems = group.infoItems,
        hideBottomLine = group.hideBottomLine;
      return /*#__PURE__*/_jsxs("div", {
        className: classnames('policy-info-group-container', {
          'policy-info-group-container-no-bottom-line': hideBottomLine
        }),
        children: [sectionName && /*#__PURE__*/_jsx("div", {
          className: "group-section-name",
          children: /*#__PURE__*/_jsx(Typography, {
            level: "h4",
            children: sectionName
          })
        }), infoItems.map(function (item, index) {
          var title = item.title,
            info = item.info,
            hide = item.hide;
          var textArr = Array.isArray(info) ? info : [info];
          if (hide) {
            return;
          }
          return /*#__PURE__*/_jsxs("div", {
            className: "group-policy-info",
            children: [/*#__PURE__*/_jsx("div", {
              className: "group-policy-info-title",
              children: /*#__PURE__*/_jsx(Typography, {
                level: "body1",
                children: title
              })
            }), textArr.map(function (textItem, index) {
              var text = textItem.text,
                link = textItem.link;
              if (typeof textItem === 'string' || link === undefined || link.length === 0) {
                return /*#__PURE__*/_jsx("div", {
                  className: "group-policy-info-text",
                  children: /*#__PURE__*/_jsx(Typography, {
                    level: "body1",
                    children: textItem
                  })
                }, index);
              }
              var linkArr = Array.isArray(link) ? link : [link];
              var onlyOneLink = linkArr.length === 1;
              if (onlyOneLink) {
                var onClick = link.onClick;
                return /*#__PURE__*/_jsxs("div", {
                  className: "group-policy-info-text",
                  children: [/*#__PURE__*/_jsx(Typography, {
                    level: "body1",
                    children: text
                  }), /*#__PURE__*/_jsx(Button, {
                    onClick: onClick ? function () {
                      return onClick(props);
                    } : function () {},
                    type: "link",
                    children: link.linkText
                  })]
                }, index);
              }
              return /*#__PURE__*/_jsxs("div", {
                className: "group-text-and-link-mult-link",
                children: [/*#__PURE__*/_jsx(Typography, {
                  level: "body1",
                  children: text
                }), linkArr.map(function (linkObj, index) {
                  var onClick = linkObj.onClick;
                  return /*#__PURE__*/_jsx("div", {
                    style: {
                      marginTop: 2
                    },
                    children: /*#__PURE__*/_jsx(Button, {
                      onClick: onClick ? function () {
                        return onClick(props);
                      } : function () {},
                      type: "link",
                      children: linkObj.linkText
                    })
                  }, index);
                })]
              }, index);
            })]
          }, index);
        })]
      }, index);
    })]
  });
};
export default MobileInsurerDetail;